import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { loginAction } from "redux/actions/auth/loginAction";
import { useNavigate } from "react-router-dom";
import { HOME_PATH } from "Routes/paths";
import { useTranslation } from "react-i18next";

interface loginTypes {
  email: string;
  password: string;
}

const useLoginFormik = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validationSchema: yup.object({
      email: yup
        .string()
        .email(`${t("email must be a valid email")}`)
        .required(`${t("This field is required")}`),
      password: yup
        .string()
        .min(8, `${t("password must be at least 8 characters long")}`)
        .matches(
          new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/),
          `${t("must contain lowercase, uppercase letter, one number")}`
        )
        .required(`${t("This field is required")}`),
    }),

    onSubmit: async (values: loginTypes) => {
      await dispatch(
        loginAction(
          {
            email_id: values.email,
            password: values.password,
            login_type: "email",
          },
          () => {
            navigate(`${HOME_PATH}`);
          }
        )
      );
    },
  });

  return formik;
};

export { useLoginFormik };
